export default __webpack_public_path__ + "static/media/morning_img.6fe4769e.png";